import styled from "styled-components";
import { COLORS } from "@bikdotai/bik-component-library";

export const CheckboxCard = styled.div<{ onClick: () => void }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid ${COLORS.stroke.primary};
  border-radius: 8px;
  background-color: ${COLORS.surface.standard};
  cursor: pointer;
  
  &:hover {
    background-color: ${COLORS.surface.hovered};
  }
`;

export const CheckboxLabel = styled.div`
  color: ${COLORS.content.primary};
  flex: 1;
  word-break: break-word;
  white-space: normal;
  line-height: 1.5;
`;

export const ConfigSection = styled.div`
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 8px;
  background: ${COLORS.surface.standard};
`;

export const CurrencySymbol = styled.span<{ position: 'left' | 'right' }>`
  position: absolute;
  ${props => props.position === 'left' ? 'left: 16px;' : 'right: 16px;'}
  top: 40px;
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 400;
  z-index: 1;
  pointer-events: none;
`;


